import { ActionList, Badge, Button, ButtonGroup, FormLayout, InlineStack, Modal, Popover, Select, Text, TextField, BlockStack } from "@shopify/polaris";
import { CirclePlusMinor } from "@shopify/polaris-icons";
import React, { Dispatch, useCallback, useEffect, useState } from "react";
import { DI, DIProps } from "../../../../Core";
import CountrySelection from "./CountrySelection";
import { useTranslation } from "react-i18next";
interface ShipFromI { name: string, email: string, phone: string, address_line_1: string, address_line_2: string, country: string, state: string, city: string, zip: string, error: boolean, tag: string, from_warehouse: boolean }
interface PropsI extends DIProps {
    ship_from: ShipFromI,
    setShipFrom: Dispatch<React.SetStateAction<ShipFromI>>,
    data: any,
}

const Ship_From = ({ ship_from, setShipFrom, data, ...props }: PropsI) => {
    const { t } = useTranslation();
    const [popoverActive, setPopoverActive] = useState(false);

    const warehouses = [
        ...(props?.redux?.current?.source?.warehouses ?? []),
        { ...(data?.default_ship_from_address ?? {}), active: true, tag: 'Default' },
    ].filter(w => w?.active)
        .map((warehouse) => {
            const fieldValue = {
                "name": warehouse.name,
                "email": warehouse?.email ?? "",
                "phone": warehouse?.phone ?? "",
                "address_line_1": warehouse?.address1 ?? warehouse?.address_line_1 ?? "",
                "address_line_2": warehouse?.address2 ?? warehouse?.address_line_2 ?? "",
                "country": warehouse?.country ?? "",
                "state": warehouse?.state ?? "",
                "city": warehouse?.city ?? "",
                "zip": warehouse?.zip ?? "",
                "tag": warehouse?.tag ? warehouse?.tag : t('Warehouse'),
                "from_warehouse": true
            }
            if (!fieldValue.name || !fieldValue.address_line_1 || !fieldValue.city || !fieldValue.country || !fieldValue.zip) return null;
            const value = `${fieldValue.name}, ${fieldValue.address_line_1}, ${fieldValue.address_line_2}, ${fieldValue.city}, ${fieldValue.state} ${fieldValue.country}, ${fieldValue.zip} `
            return {
                content: <Text as='p'>{value}<Badge>{fieldValue.tag}</Badge></Text>,
                additional_data: fieldValue,
                value,
                onAction: () => {
                    setShipFrom({ ...fieldValue, error: false, });
                    setPopoverActive(false)
                }
            }
        }).filter(a => a)

    const [activeAddressModal, setActiveAddressModal] = useState(false);
    const [list, setList] = useState<any[]>([])
    const [textFieldValue, setTextFieldValue] = useState({ name: '', email: '', phone: '', address_line_1: '', address_line_2: '', country: '', state: '', city: '', zip: '', tag: '', error: false, from_warehouse: false });

    const handleTextFieldChange = useCallback((value: string, id: string) => {
        setTextFieldValue(a => ({ ...a, [id]: value, error: false }))
    }, []);

    const saveAddress = () => {
        if (
            !textFieldValue.name ||
            !textFieldValue.address_line_1 ||
            !textFieldValue.city ||
            !textFieldValue.country ||
            !textFieldValue.zip ||
            (textFieldValue?.phone && !/^(\+\d{1,3}[- ]?)?\d{10}$/.test(textFieldValue.phone)) ||
            (textFieldValue.email && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(textFieldValue.email))

        ) {
            setTextFieldValue(a => ({ ...a, error: true }));
            return;
        }

        !textFieldValue.from_warehouse && props.di.POST('connector/profile/createUpdateTemplate', {
            "name": "shipping_details",
            "type": "shipping_services",
            "marketplace": "amazon",
            "use_user_id": true,
            "user_id": props.redux.user_id,
            "ship_from_address": [{ ...textFieldValue, error: false, tag: textFieldValue?.tag || 'Custom' }, ...list.map((item) => item.additional_data)]
        },).then((response) => {
            if (!response.success) props.error(t(response.message) ?? '')
        })
        const value = `${textFieldValue.name}, ${textFieldValue.address_line_1}, ${textFieldValue.address_line_2}, ${textFieldValue.city}, ${textFieldValue.state} ${textFieldValue.country}, ${textFieldValue.zip} `
        setActiveAddressModal(false)
        setShipFrom({ ...textFieldValue, error: false, tag: textFieldValue?.tag || 'Custom' });
        setTextFieldValue({ name: '', email: '', phone: '', address_line_1: '', address_line_2: '', country: '', state: '', city: '', zip: '', tag: '', from_warehouse: false, error: false });
        if (!list.find((item) => item?.value?.includes(value)))
            setList([{
                content: <Text as='p'>{value}<Badge>{textFieldValue?.tag || 'Custom'}</Badge></Text>,
                additional_data: textFieldValue,
                value,
                onAction: () => {
                    setShipFrom({ ...textFieldValue, error: false, tag: textFieldValue?.tag || 'Custom' });
                    setPopoverActive(false)
                }
            }, ...list])
    }

    useEffect(() => {

        let temp_list = [...(data?.template_data?.ship_from_address ?? []).map((add: any) => {
            let val = {
                name: add?.name ?? '',
                email: add?.email ?? '',
                phone: add?.phone ?? '',
                address_line_1: add?.address_line_1 ?? '',
                address_line_2: add?.address_line_2 ?? '',
                country: add?.country ?? '',
                state: add?.state ?? '',
                city: add?.city ?? '',
                tag: add?.tag || 'Custom',
                zip: add?.zip ?? ''
            }
            if (!val.name ||
                !val.address_line_1 ||
                !val.city ||
                !val.country ||
                !val.zip ||
                (val?.phone && !/^(\+\d{1,3}[- ]?)?\d{10}$/.test(val.phone)) ||
                (val.email && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(val.email))
            ) return;
            let content = `${val.name}, ${val.address_line_1}, ${val.address_line_2}, ${val.city}, ${val.state} ${val.country}, ${val.zip} `
            return {
                content: <Text as='p'>{content}<Badge>{val?.tag || 'Custom'}</Badge></Text>,
                value: content,
                additional_data: val,
                onAction: () => { setShipFrom({ ...val, error: false, tag: val?.tag || 'Custom', from_warehouse: false }); setPopoverActive(a => false); }
            }
        })].filter((a: any) => a);

        setList([...temp_list])
    }, [data?.template_data])

    const ship_from_selected = ship_from.name && ship_from.address_line_1 && ship_from.city && ship_from.country && ship_from.zip
    const label_generated = !!data?.shipping_services?.[0]?.label_generated

    const activatorShip = (
        <Button textAlign='left' fullWidth onClick={() => { setShipFrom(a => ({ ...a, error: false })); setPopoverActive(a => !a) }} disclosure tone={ship_from.error ? 'critical' : undefined} variant={ship_from.error ? 'primary' : undefined} >
            {ship_from_selected ? `${ship_from.name}, ${ship_from.address_line_1}, ${ship_from.address_line_2}, ${ship_from.city}, ${ship_from.state} ${ship_from.country}, ${ship_from.zip}` : 'Select ship from'}
        </Button>
    );

    return <>
        {!label_generated && <Popover
            fullWidth
            active={popoverActive}
            activator={activatorShip}
            autofocusTarget="first-node"
            onClose={() => { setPopoverActive(false) }}
        >
            <Popover.Pane>
                <ActionList
                    actionRole="menuitem"
                    items={[...list, ...warehouses]}
                />
            </Popover.Pane>
            <Popover.Pane>
                <ActionList
                    actionRole="menuitem"
                    items={[
                        { content: t('Add new address'), icon: CirclePlusMinor, onAction: () => setActiveAddressModal(true) },
                    ]}
                />
            </Popover.Pane>
        </Popover>}
        {ship_from_selected &&
            <InlineStack align='space-between' blockAlign='start'>
                <BlockStack gap="200">
                    <Text variant="headingSm" as="h6">
                        {t("Selected address")}
                    </Text>
                    <BlockStack gap="0">
                        <InlineStack gap="200">
                            <Text as="p" fontWeight="regular">
                                {ship_from.name + ' '}
                                <Badge>{ship_from?.tag || 'Custom'}</Badge>
                            </Text>
                        </InlineStack>
                        <Text as="p" fontWeight="regular">
                            {ship_from.address_line_1}
                        </Text>
                        {ship_from.address_line_2 &&
                            <Text as="p" fontWeight="regular">
                                {ship_from.address_line_2}
                            </Text>}
                        <Text as="p" fontWeight="regular">
                            {ship_from.city}, {ship_from.state}
                        </Text>
                        <Text as="p" fontWeight="regular">
                            {ship_from.country}, {ship_from.zip}
                        </Text>
                    </BlockStack>
                </BlockStack>
                {!label_generated && <ButtonGroup>
                    <Button variant="plain" onClick={() => {
                        setTextFieldValue({ ...ship_from, tag: 'Custom' })
                        setActiveAddressModal(true)
                    }}>{t("Edit")}</Button>
                    <Button variant="plain" tone="critical" onClick={() => { setShipFrom({ name: '', email: '', phone: '', address_line_1: '', address_line_2: '', country: '', state: '', city: '', zip: '', error: false, tag: '', from_warehouse: false }) }}>{t("Remove")}</Button>
                </ButtonGroup>}
            </InlineStack>
        }
        <Modal
            size="large"
            open={activeAddressModal}
            onClose={() => {
                setTextFieldValue({ name: '', email: '', phone: '', address_line_1: '', address_line_2: '', country: '', state: '', city: '', zip: '', tag: '', from_warehouse: false, error: false })
                setActiveAddressModal(false)
            }}
            title={t("Ship From")}
            primaryAction={{
                content: t('Save'),
                onAction: saveAddress,
            }}
        >
            <Modal.Section>
                <BlockStack gap="300">
                    <FormLayout>
                        <FormLayout.Group condensed>
                            <TextField label={t("Name")} requiredIndicator id='name' value={textFieldValue.name} type="text" onChange={handleTextFieldChange} autoComplete="off" error={textFieldValue.error && !textFieldValue.name} maxLength={32} showCharacterCount />
                            <TextField label={t("Email ID")} id='email' value={textFieldValue.email} type="email" onChange={handleTextFieldChange} autoComplete="off" error={textFieldValue.error && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(textFieldValue.email)} />
                            <TextField label={t("Phone Number")} id='phone' value={textFieldValue.phone} onChange={handleTextFieldChange} autoComplete="off" error={textFieldValue.error && !/^(\+\d{1,3}[- ]?)?\d{10}$/.test(textFieldValue.phone)} />
                            <TextField label={t("Address Nickname")} id='tag' value={textFieldValue.tag} onChange={handleTextFieldChange} autoComplete="off" />
                        </FormLayout.Group>
                    </FormLayout>
                    <FormLayout>
                        <FormLayout.Group condensed>
                            <TextField label={t("Address Line 1")} id='address_line_1' value={textFieldValue.address_line_1} type="text" onChange={handleTextFieldChange} autoComplete="off" error={textFieldValue.error && !textFieldValue.address_line_1} requiredIndicator maxLength={60} showCharacterCount />
                        </FormLayout.Group>
                    </FormLayout>
                    <FormLayout>
                        <FormLayout.Group condensed>
                            <TextField label={t("Address Line 2")} id='address_line_2' value={textFieldValue.address_line_2} type="text" onChange={handleTextFieldChange} autoComplete="off" maxLength={60} showCharacterCount />
                        </FormLayout.Group>
                    </FormLayout>
                    <CountrySelection textFieldValue={textFieldValue} onChange={handleTextFieldChange} />
                </BlockStack>
            </Modal.Section>
        </Modal>
    </>;
}

export default DI(Ship_From);
